import { Alert, Typography } from "@braintrust/braintrust-ui-components";

export type LocationMismatchAlertProps = {
  userFirstName: string;
  sessionLocationMismatch: boolean;
  billingLocationMismatch: boolean;
  className?: string;
};

export const LocationMismatchAlert = ({
  userFirstName,
  sessionLocationMismatch,
  billingLocationMismatch,
  className,
}: LocationMismatchAlertProps) => {
  if (!sessionLocationMismatch && !billingLocationMismatch) {
    return null;
  }

  return (
    <Alert
      type="error"
      data-testid="location-mismatch-alert"
      className={className}
      sx={{
        backgroundColor: "var(--medium-red)",
        padding: "20px",
        borderRadius: "11px",
        width: "unset",
        justifyContent: "flex-start",
      }}
      contentSx={{ padding: 0 }}
    >
      <Typography component="p" variant="paragraph" size="medium">
        {getLocationMismatchAlertContent({
          userFirstName,
          sessionLocationMismatch,
          billingLocationMismatch,
        })}
      </Typography>
    </Alert>
  );
};

const getLocationMismatchAlertContent = ({
  userFirstName,
  sessionLocationMismatch,
  billingLocationMismatch,
}: LocationMismatchAlertProps) => {
  if (sessionLocationMismatch && billingLocationMismatch) {
    return `📍 There are multiple discrepancies with ${userFirstName}’s location.`;
  }

  if (sessionLocationMismatch) {
    return `📍 ${userFirstName}’s profile location does not match their last active session.`;
  }

  return `📍 ${userFirstName}’s profile location does not match their billing location.`;
};
